import { useApi } from "utils";
import { ApprovalBillServiceParams, ApprovalBillServiceSchema } from "../types";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { DataTypePaging } from "types";

export const useGetListApprovalBillService = ({ page, approval_status, limit }: ApprovalBillServiceParams) => {
  const defaultValue = {
    payload: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0
    }
  }

  const api = useApi();
  const [data, setData] = useState<DataTypePaging<ApprovalBillServiceSchema>>(defaultValue);
  const [isLoading, setLoading] = useState(true)

  const fetchUrl = () => api.get(`/probill/get-approval-bill-service?approve_status=${approval_status}&page=${page}&limit=${limit}`)

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<DataTypePaging<ApprovalBillServiceSchema>>) => setData(res.data))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    }

    // eslint-disable-next-line
  }, [page, approval_status, limit]);

  return { data, isLoading, refetch }
}